export enum KlassPeriodEnum {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
}

export const klassPeriodRanges = {
  [KlassPeriodEnum.MORNING]: {
    timeAfter: '00:00:00',
    timeBefore: '11:59:00',
  },
  [KlassPeriodEnum.AFTERNOON]: {
    timeAfter: '12:00:00',
    timeBefore: '17:59:59',
  },
  [KlassPeriodEnum.EVENING]: {
    timeAfter: '18:00:00',
    timeBefore: undefined,
  },
} as const;
